import * as React from "react"
import { SVGProps } from "react"
const ArrowLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={12}
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M15.682 5.221v1.554H0V5.221z" />
    <path
      fill="#fff"
      d="M14.128 5.535h1.554v5.378h-1.554zM5.22 0 6.32 1.099l-5.22 5.22L0 5.219z"
    />
    <path fill="#fff" d="m6.319 10.896-1.1 1.099L0 6.775l1.099-1.099z" />
  </svg>
)
export default ArrowLeftIcon
